<template>
  <vs-popup
    :active.sync="isActive"
    v-esc="escape"
    :title="draw.title ? draw.title : 'Yeni Çekiliş Oluştur'"
    id="newDrawPage"
  >
    <vs-popup
      class="holamundo"
      title="Boy Seçimi"
      :active.sync="isSizeSelection"
    >
      <vs-row vs-type="flex"  vs-justify="center">
        <vs-checkbox
          v-for="size in productSizes"
          :key="size.id"
          class="mx-2 my-1 weight-600"
          v-model="sizeSelection.selections"
          :vs-value="size"
          >{{ size.name }}
        </vs-checkbox>
      </vs-row>
      <vs-row vs-type="flex"  class="mt-3" vs-justify="flex-end">
        <vs-button
          type="gradient"
          color="success"
          icon-pack="feather"
          icon="icon-save"
          @click="confirmSizeSelection"
        >
          {{
            sizeSelection.selections.length == 0
              ? "Tüm Boylar için Onayla"
              : sizeSelection.selections.length + " Boy için Onayla"
          }}
        </vs-button>
      </vs-row>
    </vs-popup>
    <vs-row vs-type="flex" >
      <vs-tabs alignment="center">
        <vs-tab label="Genel Bilgiler">
          <div class="tab-text" id="drawGeneralOptions">
            <form data-vv-scope="drawGeneralPage">
              <vs-row vs-type="flex" >
                <vs-row vs-type="flex" >
                  <span class="w-full text-small text-primary weight-600"
                    >Çekiliş Başlık</span
                  >
                  <vs-tabs fill>
                    <vs-tab label="Türkçe" title="Türkçe" active>
                      <vs-input
                        :readonly="!$isCenterBranch()"
                        class="w-full"
                        name="Başlık"
                        v-validate="'required'"
                        v-model="draw.title"
                        placeholder="Çekiliş Başlık"
                      />
                      <span
                        class="text-danger text-xsmaller"
                        v-show="errors.has('drawGeneralPage.Başlık')"
                        >{{ errors.first("drawGeneralPage.Başlık") }}</span
                      >
                    </vs-tab>
                    <vs-tab label="İngilizce" title="İngilizce">
                      <vs-input
                        :readonly="!$isCenterBranch()"
                        class="w-full"
                        name="Başlık İngilizce"
                        v-validate="'required'"
                        v-model="draw.titleEn"
                        placeholder="Çekiliş İngilizce Başlık"
                      />
                      <span
                        class="text-danger text-xsmaller"
                        v-show="errors.has('drawGeneralPage.Başlık İngilizce')"
                        >{{
                          errors.first("drawGeneralPage.Başlık İngilizce")
                        }}</span
                      >
                    </vs-tab>
                  </vs-tabs>
                </vs-row>
                <vs-divider color="primary"></vs-divider>
                <vs-row vs-type="flex" vs-justify="space-between"  >
                  <vs-col vs-type="flex"  vs-xs="12" class="responsiveMargin"   >
                    <vs-row vs-type="flex" >
                      <vs-row
                        vs-type="flex"
                        
                        vs-align="center"
                        vs-justify="center"
                      >
                        <vx-tooltip
                          text="Fotoğraf Güncelle"
                          color="primary"
                          position="bottom"
                          class="w-full"
                        >
                          <div
                            class="w-full flex campaignImg pointer"
                            @click="
                              $isCenterBranch()
                                ? $refs.uploadImgInput.click()
                                : null
                            "
                          >
                            <input
                              type="file"
                              class="hidden"
                              ref="uploadImgInput"
                              @change="updateCurrImg"
                              accept="image/*"
                            />
                            <vs-button
                              size="large"
                              color="transparent"
                              v-if="draw.image == null && $isCenterBranch()"
                              icon-pack="feather"
                              icon="icon-upload"
                              class="m-auto"
                            >
                              Fotoğraf
                            </vs-button>
                            <img
                              v-if="draw.image != null && !needUpload"
                              :src="$baseUrl + '/' + draw.image"
                              alt="img"
                              class="responsive"
                            />
                            <img
                              v-if="draw.image != null && needUpload"
                              :src="draw.image"
                              alt="img"
                              class="responsive"
                            />
                          </div>
                        </vx-tooltip>
                      </vs-row>
                      <vs-row
                        v-if="!$isNullOrEmpty(draw.image)"
                        class="mt-2"
                        vs-type="flex"
                        
                      >
                        <vs-button
                          class="w-full p-2"
                          color="danger"
                          @click="draw.image = null"
                        >
                          Fotoğrafı Sil
                        </vs-button>
                      </vs-row>
                    </vs-row>
                  </vs-col>
                 
                  <vs-col vs-type="flex"  vs-xs="12" class="responsiveMargin" >
                    <vs-row vs-type="flex" >
                      <vs-row vs-type="flex" >
                        <vs-tabs fill>
                          <vs-tab label="Türkçe" title="Türkçe" active>
                            <vs-textarea
                              :readonly="!$isCenterBranch()"
                              :disabled="!$isCenterBranch()"
                              id="drawDesc"
                              v-validate="'required'"
                              name="Açıklama"
                              v-model="draw.description"
                              class="w-full mb-0"
                              label="Açıklama"
                            />
                          </vs-tab>
                          <vs-tab label="İngilizce" title="İngilizce">
                            <vs-textarea
                              :readonly="!$isCenterBranch()"
                              :disabled="!$isCenterBranch()"
                              id="drawDesc"
                              v-validate="'required'"
                              name="Açıklama İngilizce"
                              v-model="draw.descriptionEn"
                              class="w-full mb-0"
                              label="Açıklama"
                            />
                          </vs-tab>
                        </vs-tabs>
                      </vs-row>
                      <vs-row vs-type="flex" >
                        <span
                          class="text-danger text-xsmaller"
                          v-show="errors.has('drawGeneralPage.Açıklama')"
                          >{{ errors.first("drawGeneralPage.Açıklama") }}
                        </span>
                        <span
                          class="text-danger text-xsmaller"
                          v-show="
                            errors.has('drawGeneralPage.Açıklama İngilizce')
                          "
                          >{{
                            errors.first("drawGeneralPage.Açıklama İngilizce")
                          }}
                        </span>
                      </vs-row>
                    </vs-row>
                  </vs-col>
                </vs-row>
                <vs-divider color="primary"></vs-divider>
                <vs-row vs-type="flex" >
                  <vs-col vs-type="flex" >
                    <vs-row vs-type="flex"  vs-justify="space-between" >
                      <vs-col vs-type="block"  >
                        <span class="w-full text-small text-primary weight-600"
                          >Başlangıç Tarihi</span
                        >
                        <datepicker
                          :disabled="!$isCenterBranch()"
                          :disabled-dates="{ to: $now.date() }"
                          placeholder="Başlangıç Tarihi"
                          class="w-full"
                          :language="turkish"
                          format="yyyy MMM d"
                          v-model="draw.dateRange.startDate"
                        />
                        <span
                          class="text-danger text-xsmaller"
                          v-show="!draw.dateRange.startDate"
                          >Başlangıç Tarihi Seçiniz.</span
                        >
                      </vs-col>
                      <vs-col vs-type="block"    >
                        <span class="w-full text-small text-primary weight-600"
                          >Bitiş Tarihi</span
                        >
                        <datepicker
                          :disabled="
                            !draw.dateRange.startDate || !$isCenterBranch()
                          "
                          :disabled-dates="
                            draw.dateRange.startDate
                              ? { to: draw.dateRange.startDate }
                              : { to: $now.date() }
                          "
                          placeholder="Bitiş Tarihi"
                          class="w-full"
                          :language="turkish"
                          format="yyyy MMM d"
                          v-model="draw.dateRange.endDate"
                        />
                        <span
                          class="text-danger text-xsmaller"
                          v-show="!draw.dateRange.endDate"
                          >Bitiş Tarihi Seçiniz.</span
                        >
                      </vs-col>
                    </vs-row>
                  </vs-col>
                </vs-row>
                <vs-divider color="primary"></vs-divider>
                <vs-row vs-type="flex" >
                  <vs-col vs-type="flex" >
                    <vs-row vs-type="flex" >
                      <vs-col vs-type="block" >
                        <span class="w-full text-small text-primary weight-600"
                          >Çekiliş Tarihi</span
                        >
                        <datepicker
                          :disabled="
                            !draw.dateRange.endDate || !$isCenterBranch()
                          "
                          :disabled-dates="
                            draw.dateRange.endDate
                              ? { to: draw.dateRange.endDate }
                              : { to: $now.date() }
                          "
                          placeholder="Çekiliş Tarihi"
                          class="w-full"
                          :language="turkish"
                          format="yyyy MMM d"
                          v-model="draw.drawDate"
                        />
                        <span
                          class="text-danger text-xsmaller"
                          v-show="!draw.drawDate"
                          >Çekiliş Tarihi Seçiniz.</span
                        >
                      </vs-col>
                      <vs-col vs-type="block" >
                        <span class="w-full text-small text-primary weight-600"
                          >Bilet Prefix</span
                        >
                        <vs-input
                          :disabled="draw.id"
                          class="w-full"
                          name="Bilet Prefix"
                          v-validate="{ required: true }"
                          v-model="draw.prefix"
                          placeholder="{Prefix}00000000"
                        />
                        <span
                          class="w-full text-danger text-xsmaller"
                          v-if="errors.has('drawGeneralPage.Bilet Prefix')"
                          >{{
                            errors.first("drawGeneralPage.Bilet Prefix")
                          }}</span
                        >
                        <span v-else class="w-full text-warning text-xsmaller">
                          Örnek Bilet Numarası : {{ getExampleTicket() }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                </vs-row>
              </vs-row>
            </form>
          </div>
        </vs-tab>
        <vs-tab label="Katılım Şartları">
          <div class="tab-text" id="drawRestOptions">
            <form data-vv-scope="drawRestTab">
              <vs-row vs-type="flex" >
                <vs-row vs-type="flex"  vs-justify="space-between">
                  <vs-col vs-type="flex" >
                    <vs-row vs-type="flex" >
                      <span class="w-full text-small text-primary weight-600"
                        >Şart Türü</span
                      >
                      <v-select
                        size="small"
                        class="w-full"
                        id="restEntityType"
                        name="Şart Türü"
                        v-validate="'required'"
                        v-model="draw.entityType"
                        itemid="id"
                        label="dName"
                        placeholder="Şart Tür Seçimi.."
                        @input="
                          fillRestOptions();
                          selectedRestOptions.length = 0;
                        "
                        :options="
                          entityTypes.filter(
                            (x) => x.enabled && x.id != 'PRICE'
                          )
                        "
                        :reduce="(x) => x.name"
                        :clearable="false"
                      />
                      <span
                        class="w-full text-danger text-xsmaller"
                        v-show="errors.has('drawRestTab.Şart Türü')"
                        >{{ errors.first("drawRestTab.Şart Türü") }}</span
                      >
                    </vs-row>
                  </vs-col>
                  <vs-col vs-type="flex">
                    <vs-row vs-type="flex" >
                      <span class="w-full text-small text-primary weight-600"
                        >Şart Miktar Türü</span
                      >
                      <v-select
                        size="small"
                        class="w-full"
                        name="Miktar Türü"
                        v-validate="'required'"
                        v-model="draw.amountType"
                        itemid="id"
                        label="dName"
                        placeholder="Tür Seçimi.."
                        :options="amountTypesRest.filter((x) => x.enabled)"
                        :reduce="(x) => x.name"
                        :clearable="false"
                      />
                      <span
                        class="text-danger text-xsmaller"
                        v-show="errors.has('drawRestTab.Miktar Türü')"
                        >{{ errors.first("drawRestTab.Miktar Türü") }}</span
                      >
                    </vs-row>
                  </vs-col>
                  <vs-col vs-type="flex" >
                    <vs-row vs-type="flex" >
                      <span class="w-full text-small text-primary weight-600"
                        >Şart Miktarı</span
                      >
                      <vs-input
                        class="w-full"
                        name="Şart Miktarı"
                        v-validate="{
                          required: true,
                          regex: /^\d{0,10}(\.\d{0,10}){0,1}$/,
                        }"
                        v-model="draw.amount"
                        placeholder="Miktar"
                      />
                      <span
                        class="text-danger text-xsmaller"
                        v-show="errors.has('drawRestTab.Şart Miktarı')"
                        >{{ errors.first("drawRestTab.Şart Miktarı") }}</span
                      >
                    </vs-row>
                  </vs-col>
                </vs-row>
                <vs-divider
                  color="primary"
                  v-if="draw.entityType && draw.entityType != 'cart'"
                />
                <vs-row
                  vs-type="flex"
                  vs-xs="12" vs-md="8" vs-lg="8"  
                  v-if="draw.entityType && draw.entityType != 'cart'"
                >
                  <vs-col vs-type="flex"  vs-xs="12" vs-md="5" vs-lg="5" >
                    <vs-row vs-type="flex" >
                      <vs-list>
                        <vs-row vs-type="flex" >
                          <vs-col vs-type="flex" >
                            <vs-list-header
                              icon-pack="feather"
                              icon="icon-award"
                              title="Şart Seçenekleri"
                              color="primary"
                              class="w-full sale-box-shadow p-2"
                            />
                          </vs-col>
                        </vs-row>
                        <vs-row vs-type="flex" >
                          <vs-input
                            v-model="filterRestString"
                            class="w-full border-radius border-all"
                            placeholder="Şart Arama"
                          />
                        </vs-row>
                        <draggable
                          :list="filteredRestOptions"
                          group="restOptions"
                          class="p-2 cursor-move"
                          @change="onEndSelectionFromDefaults"
                        >
                        <div  v-if="filteredRestOptions.length>0" >
                          <div
                            class="w-full d-flex my-1"
                            :class="{ selectedBranch: rest.selected }"
                            @click="rest.selected = !rest.selected"
                            v-for="rest in filteredRestOptions"
                            :key="rest.id"
                          >
                            <vs-list-item
                              class="campaignBranchList text-smaller"
                              :title="rest.name"
                            >
                              <template slot="avatar">
                                <vs-avatar
                                  class="sale-box-shadow"
                                  :src="
                                    rest.imageUrl
                                      ? $baseUrl + '/' + rest.imageUrl
                                      : require('@/assets/images/products/product-kahve.png')
                                  "
                                />
                              </template>
                            </vs-list-item>
                         
                          </div> 
                         </div>
                         <div class="mt-3" v-else ><span >Şart Bulunamadı</span></div>
                        </draggable>
                      </vs-list>
                    </vs-row>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-xs="12" vs-md="2" vs-lg="2" class="px-2 mb-6" 
                 
                    vs-justify="center"
                    vs-align="center"
                  >
                    <vs-row vs-type="flex" >
                      <vx-tooltip
                        text="Hepsini Sola Al"
                        color="primary"
                        position="top"
                        class="w-full"
                      >
                        <vs-button
                          v-if="$isCenterBranch()"
                          :disabled="draw.isPublished"
                          @click="moveToLeft(false, 'rest')"
                          class="w-full sale-box-shadow"
                          icon-pack="feather"
                          icon="icon-chevrons-left"
                          color="danger"
                        />
                      </vx-tooltip>
                      <vx-tooltip
                        text="Sola Al"
                        color="primary"
                        position="left"
                        class="w-full"
                      >
                        <vs-button
                          v-if="$isCenterBranch()"
                          :disabled="draw.isPublished"
                          @click="moveToLeft(true, 'rest')"
                          class="w-full mt-4"
                          icon-pack="feather"
                          icon="icon-arrow-left"
                          color="secondary"
                        />
                      </vx-tooltip>
                      <vx-tooltip
                        text="Sağa Al"
                        color="primary"
                        position="right"
                        class="w-full"
                      >
                        <vs-button
                          v-if="$isCenterBranch()"
                          :disabled="draw.isPublished"
                          @click="moveToRight(true, 'rest')"
                          class="w-full mt-2"
                          icon-pack="feather"
                          icon="icon-arrow-right"
                          color="secondary"
                        />
                      </vx-tooltip>
                      <vx-tooltip
                        text="Hepsini Sağa Al"
                        color="primary"
                        position="bottom"
                        class="w-full"
                      >
                        <vs-button
                          v-if="$isCenterBranch()"
                          :disabled="draw.isPublished"
                          @click="moveToRight(false, 'rest')"
                          class="w-full mt-4 sale-box-shadow"
                          icon-pack="feather"
                          icon="icon-chevrons-right"
                          color="success"
                        />
                      </vx-tooltip>
                    </vs-row>
                  </vs-col>
                  <vs-col vs-type="flex"  vs-xs="12" vs-md="5" vs-lg="5">
                    <vs-row vs-type="flex" >
                      <vs-list>
                        <vs-list-header
                          icon-pack="feather"
                          icon="icon-check"
                          title="Seçilen Şartlar"
                          class="sale-box-shadow p-2"
                          color="success"
                        >
                        </vs-list-header>
                        <draggable
                          :list="selectedRestOptions"
                          group="restOptions"
                          class="p-2 cursor-move"
                          @change="onEndSelectionFromSelecteds"
                        >
                        <div  v-if="selectedRestOptions.length>0" >
                          <div
                            class="w-full d-flex my-1"
                            :class="{ selectedBranch: rest.selected }"
                            @click="rest.selected = !rest.selected"
                            v-for="rest in selectedRestOptions"
                            :key="rest.id"
                          >
                            <vs-list-item
                              class="campaignBranchList text-smaller"
                              :title="
                                rest.name +
                                (rest.sizes != null && rest.sizes.length > 0
                                  ? rest.sizes.length > 1
                                    ? ' - ' + rest.sizes.length + ' Boy Seçildi'
                                    : ' - ' + rest.sizes[0].name
                                  : ' - Tüm Boylar Seçildi')
                              "
                            >
                              <template slot="avatar">
                                <vs-avatar
                                  class="sale-box-shadow"
                                  :src="
                                    rest.imageUrl
                                      ? $baseUrl + '/' + rest.imageUrl
                                      : require('@/assets/images/products/product-kahve.png')
                                  "
                                />
                              </template>
                            </vs-list-item>
                          </div>
                          </div>
                         <div class="mt-3" v-else ><span >Seçili Şart Bulunamadı</span></div>

                        </draggable>
                      </vs-list>
                    </vs-row>
                  </vs-col>
                </vs-row>
              </vs-row>
            </form>
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-divider color="primary"></vs-divider>
      <vs-row
        vs-type="flex"
        
        vs-justify="space-between"
        vs-align="center"
      >
        <vs-button class="mr-auto giveUpAndSaveButtons" type="gradient" color="danger" @click="escape">
          Vazgeç
        </vs-button>
        <vs-button
          v-if="$isCenterBranch() && isNewDrawPermission"
          :disabled="draw.isPublished"
          color="success"
          class="ml-auto giveUpAndSaveButtons"
          type="gradient"
          @click="submitNewDraw"
          >Kaydet
        </vs-button>
      </vs-row>
    </vs-row>
  </vs-popup>
</template>

<script>
import { CreateNewDraw, UpdateDraw } from "@/api/Draw.js";
import { GetGiftOptions } from "@/api/Campaign.js";
import { getProductSizeList } from "@/api/ProductSize.js";
import draggable from "vuedraggable";
import { tr } from "vuejs-datepicker/src/locale";
import Datepicker from "vuejs-datepicker";
import { uploadImage } from "@/api/User.js";
import {isGranted} from "@/utils/auth";
export default {
  name: "NewDraw",
  data() {
    return {
      random: Math.random().toString().slice(2, 10),
      sizeSelection: {
        indexes: [],
        selections: [],
      },
      productSizes: [],
      isSizeSelection: false,
      filterRestString: "",
      draw: {
        title: null,
        description: null,
        titleEn: null,
        descriptionEn: null,
        dateRange: {},
        image: null,
      },
      isActive: false,
      restOptions: [],
      selectedRestOptions: [],
      turkish: tr,
      needUpload: true,
      drawPhotoBinary: "",
      amountTypesRest: [
        {
          id: "PIECE",
          name: "piece",
          dName: "Adet",
          enabled: true,
        },
        {
          id: "AMOUNT",
          name: "amount",
          dName: "Tutar",
          enabled: true,
        },
      ],
      entityTypes: [
        {
          id: "VARIANT",
          name: "variant",
          dName: "Ürün",
          enabled: true,
        },
        {
          id: "CATEGORY",
          name: "category",
          dName: "Kategori",
          enabled: true,
        },
        {
          id: "CART",
          name: "cart",
          dName: "Sepet",
          enabled: true,
        },
      ],
    };
  },
  components: {
    Datepicker,
    draggable,
  },
  computed: {
    filteredRestOptions() {
      if (!this.filterRestString) return this.restOptions;
      return this.restOptions.filter((x) =>
        x.name.toLowerCase().includes(this.filterRestString.toLowerCase())
      );
    },
    isNewDrawPermission(){
      return isGranted("draw_write")
    }
  },
  created() {
    this.getProductSizeList();
  },
  methods: {
    getExampleTicket() {
      let prefix = this.draw.prefix;
      if (!prefix) {
        prefix = "{PREFIX}";
      }
      return prefix + this.random;
    },
    confirmSizeSelection() {
      let dataSet = [];
      dataSet = this.selectedRestOptions;
      if (this.sizeSelection.indexes != -1)
        this.sizeSelection.indexes.forEach((x) => {
          let obj = dataSet.find((y) => y.id == x);
          obj.sizes = _.cloneDeep(this.sizeSelection.selections);
        });
      else
        dataSet.map(
          (x) => (x.sizes = _.cloneDeep(this.sizeSelection.selections))
        );
      this.isSizeSelection = false;
      this.sizeSelection.indexes = [];
      this.sizeSelection.selections.length = 0;
    },
    onEndSelectionFromSelecteds(val) {
      if (!val.added) return;
      if (val.added.element.sizes == null) val.added.element.sizes = [];
      this.sizeSelection.indexes.push(val.added.element.id);
      this.sizeSelection.selections = _.cloneDeep(val.added.element.sizes);
      this.isSizeSelection = true;
    },
    onEndSelectionFromDefaults(val) {
      if (!val.added) return;
      this.restOptions[val.added.newIndex].sizes.length = 0;
    },
    escape() {
      if (this.isActive == true) this.isActive = false;
    },
    updateCurrImg(input) {
      this.needUpload = true;
      if (input.target.files && input.target.files[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.draw.image = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
        this.drawPhotoBinary = input.target.files[0];
      }
    },
    uploadImage: async function () {
      let image = this.drawPhotoBinary;
      let formData = new FormData();
      formData.append("image", image);
      await uploadImage(formData)
        .then((res) => {
          if (res.status == 200) {
            this.draw.image = "StaticFiles/images/" + res.data;
            this.needUpload = false;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Kullanıcı Fotoğrafı Yüklenemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Sunucu Bağlantı Hatası",
            text: "Kullanıcı Fotoğrafı Yüklenemedi !",
          });
        });
    },
    getProductSizeList() {
      getProductSizeList()
        .then((res) => {
          if (res && res.status == 200) {
            this.productSizes = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Ürün Boyları Getirilemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata ! ",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    sortByName(array) {
      array.sort(function (a, b) {
        if (a.name > b.name) return 1;
        else if (a.name < b.name) return -1;
        else return 0;
      });
    },
    moveToLeft(selective, dataType) {
      let defaultDataSet = [];
      let dataSet = [];
      switch (dataType) {
        case "gift":
          defaultDataSet = this.giftOptions;
          dataSet = this.selectedGiftOptions;
          break;
        case "rest":
          defaultDataSet = this.restOptions;
          dataSet = this.selectedRestOptions;
          break;
        case "branch":
          defaultDataSet = this.defaultBranches;
          dataSet = this.draw.branchList;
          break;
        default:
          break;
      }
      if (!selective) {
        dataSet.forEach((x) => {
          x.sizes = [];
          defaultDataSet.unshift(x);
        });
        dataSet.length = 0;
      } else {
        let toDelete = [];
        dataSet.forEach((x, index) => {
          if (x.selected) {
            x.sizes = [];
            x.selected = false;
            defaultDataSet.push(x);
            toDelete.push(index);
          }
        });
        toDelete.forEach((x, index) => {
          dataSet.splice(x - index, 1);
        });
      }
      this.sortByName(defaultDataSet);
    },
    moveToRight(selective, dataType) {
      let defaultDataSet = [];
      let dataSet = [];
      let isSizeSelection = true;
      switch (dataType) {
        case "gift":
          defaultDataSet = this.giftOptions;
          dataSet = this.selectedGiftOptions;
          break;
        case "rest":
          defaultDataSet = this.restOptions;
          dataSet = this.selectedRestOptions;
          break;
        case "branch":
          defaultDataSet = this.defaultBranches;
          dataSet = this.draw.branchList;
          isSizeSelection = false;
          break;
        default:
          break;
      }
      if (!selective) {
        defaultDataSet.forEach((x) => {
          if (x.sizes == null) x.sizes = [];
          dataSet.unshift(x);
        });
        defaultDataSet.length = 0;
        if (isSizeSelection) {
          this.sizeSelection.indexes = -1;
          this.sizeSelection.selections = [];
          this.isSizeSelection = true;
        }
      } else {
        let toDelete = [];
        let movingIds = [];
        defaultDataSet.forEach((x, index) => {
          if (x.selected) {
            if (x.sizes == null) x.sizes = [];
            x.selected = false;
            dataSet.push(x);
            toDelete.push(index);
            movingIds.push(x.id);
          }
        });
        toDelete.forEach((x, index) => {
          defaultDataSet.splice(x - index, 1);
        });
        if (isSizeSelection) {
          this.sizeSelection.indexes = movingIds;
          this.sizeSelection.selections = [];
          this.isSizeSelection = true;
        }
      }
      this.sortByName(dataSet);
    },
    fillRestOptions() {
      if (this.draw.entityType == "cart") return;
      GetGiftOptions(this.draw.entityType)
        .then((res) => {
          if (res && res.status == 200) {
            this.restOptions = res.data;
            this.selectedRestOptions.forEach((x) => {
              let index = this.restOptions.findIndex((y) => y.id == x.id);
              if (index >= 0) this.restOptions.splice(index, 1);
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Şart Alternatifleri Getirelemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    validateDateRange() {
      if (
        this.$isNullOrEmpty.props(this.draw.dateRange) ||
        this.draw.dateRange.startDate == null ||
        this.draw.dateRange.startDate == "" ||
        this.draw.dateRange.endDate == null ||
        this.draw.dateRange.endDate == ""
      )
        return false;
      if (this.draw.dateRange.startDate <= this.draw.dateRange.endDate)
        return true;
      else return false;
    },
    submitNewDraw: async function () {
      if (!this.draw.dateRange.startDate || !this.draw.dateRange.endDate) {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Başlangıç ve Bitiş Tarihlerini Ayarlayınız.!",
        });
        return;
      }
      let checkEntityIds =
        this.draw.entityType == "cart" || this.selectedRestOptions.length > 0;
      if (!checkEntityIds) {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Katılım Şartı Seçeneği Seçiniz !",
        });
        return;
      }
      if (!this.validateDateRange()) {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Tarih Seçimi Düzeltiniz !",
        });
        return;
      }
      if (this.needUpload && this.draw.image != null) await this.uploadImage();

      this.draw.entityIds = "";
      this.selectedRestOptions.forEach((x, index) => {
        let sizesString = "";
        if (x.sizes != null) {
          x.sizes.forEach((y, indey) => {
            if (indey != x.sizes.length - 1) sizesString += y.id + "-";
            else sizesString += y.id;
          });
        }
        if (index != this.selectedRestOptions.length - 1) {
          if (!this.$isNullOrEmpty(sizesString))
            this.draw.entityIds += x.id + "/" + sizesString + "/,";
          else this.draw.entityIds += x.id + ",";
        } else {
          if (!this.$isNullOrEmpty(sizesString))
            this.draw.entityIds += x.id + "/" + sizesString + "/";
          else this.draw.entityIds += x.id;
        }
      });

      this.draw.startDate = this.$toTurkishNow(this.draw.dateRange.startDate);
      this.draw.endDate = this.$toTurkishNow(this.draw.dateRange.endDate);
      this.draw.drawDate = this.$toTurkishNow(this.draw.drawDate);
      this.draw.amount = parseFloat(this.draw.amount);
      if (this.draw.id) {
        UpdateDraw(this.draw)
          .then((res) => {
            if (res && res.status === 200) {
              if (res.data.isSuccess) {
                this.$emit("success");
                this.escape();
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı !",
                  text: "Çekiliş Başarıyla Güncellendi !",
                });
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata !",
                  text: res.data.message,
                });
              }
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata !" + res.status,
                text: "Çekiliş Güncellenemedi !",
              });
            }
          })
          .catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
      } else {
        CreateNewDraw(this.draw)
          .then((res) => {
            if (res && res.status == 200) {
              if (res.data.isSuccess) {
                this.$emit("success");
                this.escape();
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı !",
                  text: "Çekiliş Başarıyla Eklendi !",
                });
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata !",
                  text: res.data.message,
                });
              }
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata !" + res.status,
                text: "Çekiliş Eklenemedi !",
              });
            }
          })
          .catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
      }
    },
    initValues() {
      this.draw = {
        title: null,
        description: null,
        titleEn: null,
        descriptionEn: null,
        dateRange: {},
        image: null,
        isPublished: false,
        drawDate: null,
        restOptions: [],
      };
      this.restOptions = [];
      this.selectedRestOptions = [];
      this.restOptions.forEach((x) => {
        x.selected = false;
      });
      this.needUpload = true;
      this.drawPhotoBinary = "";
    },
  },
  watch: {
    "draw.entityType": function (val, oldVal) {
      if (oldVal != null) this.draw.amountType = null;
      if (val == "cart")
        this.amountTypesRest.find((x) => x.name == "piece").enabled = false;
      else this.amountTypesRest.find((x) => x.name == "piece").enabled = true;
    },
    isActive(val) {
      if (val) {
        //this.fillRestOptions();
      } else {
        this.initValues();
      }
    },
  },
};
</script>

<style>
 .vs-tabs--content{
  padding:0px !important;
  padding-bottom:10px !important;
  padding-top:10px !important;

}


#newDrawPage .campaignBranchList {
  border-bottom: 1px solid #00000040 !important;
  width: 100%;
}

#newDrawPage .selectedBranch {
  background-color: rgba(var(--vs-primary), 1);
  color: white !important;
}

.campaignImg {
  border: 1px dashed #00000040;
  min-height: 200px;
}

.campaignImg i {
  color: darkgray;
  font-size: 2rem !important;
}

.campaignImg span {
  color: darkgray;
  font-size: 1.5rem !important;
}

#newDrawPage .vs-con-textarea h4 {
  font-size: 0.9rem !important;
  color: rgba(var(--vs-primary), 1);
  font-weight: 600;
  font-size: inherit !important;
  font-family: inherit !important;
}

#newDrawPage .vs__dropdown-menu {
  max-height: 35vh !important;
  overflow-x: hidden !important;
  overflow-y: scroll !important;
  position: static !important;
}

#newDrawPage .vs-con-textarea {
  height: 22vh;
}
/* 
#newDrawPage .vs-tabs--btn {
  padding: 5px;
} */

#newDrawPage textarea {
  min-height: 85%;
  max-height: 100%;
}

#newDrawPage .vs-textarea:focus {
  resize: none !important;
}

#newDrawPage .vdp-datepicker__calendar {
  top: -268px;
}

#newDrawPage .vs-popup--content {
  padding-top: 0px !important;
  padding-bottom: 10px !important;
  margin: 0 !important;
}

#newDrawPage .vs-divider {
  margin: 10px 0 !important;
}

#drawRestOptions .vs-list {
  height: 57vh;
  overflow: auto;
}

#drawRestOptions .vs-list .cursor-move {
  height: 49vh;
  padding: 0 !important;
}

 .vs-popup {
    max-width: 800px !important;
    width: 100% !important;
  }

</style>
